$(() => {
	var url: any = $('#noticia-full-url').val();
	$('#noticia-full-url').remove();

	$('.n-c-social-btn.fb').click(() => {
		window.open(
			'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url),
			'',
			'left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0'
		);
	});

	$('.n-c-social-btn.tw').click(() => {
		window.open(
			'http://twitter.com/share?url=' + encodeURIComponent(url),
			'',
			'left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0'
		);
	});
});
